import { UserDocumentProperties } from "./userDocument.type";
import { ProfileProperties } from "./profile.type";
import { EmployeeProperties } from "./employee.type";
import { ProfessionalInformationProperties } from "./professionalInformation.type";
import { EmergencyContactProperties } from "./emergencyContact.type";
import { PortalAgentProperties } from "./portalAgent.type";
import { AgentFeeProperties } from "./agentFee.type";
import { OfficeFeeProperties } from "./officeFee.type";
import { OfficeProperties } from "./office.type";
import { EFeeFrequency, EFeePosition, EFeeStatus, EFeeType } from "./masterFee.type";
import { TeamsMemberFeeItemProperties, TeamsMemberFeeProperties } from "./teamsMemberFee.type";

export type AuthenticationData = {
	uid: string;
	identifier: string;
	disabled: boolean;
	disabledAt: Date;
	confirmed: boolean;
	confirmedAt: Date;
	isBlocked: boolean;
	blockedAt: Date;
	createdAt: Date;
	updatedAt: Date;
};

export enum EUserRole {
	admin = "admin",
	admin_general_manager = "admin_general_manager",
	admin_manager = "admin_manager",
	admin_blog = "admin_blog",
	admin_hq = "admin_hq",
	admin_finance_gm = "admin_finance_gm", // GM Finance
	admin_finance_manager = "admin_finance_manager", // Finance Manager
	admin_finance_staff = "admin_finance_staff", // Finance staff

	office_user = "office_user",

	customer = "customer",
}

export type EAdminStatus = "active" | "inactive";

export type UserProperties = {
	userId: string;
	userType: EUserRole;
	name: string;
	email: string;
	phone?: string;
	birthdate?: Date;
	birthcity?: string;
	gender: "male" | "female";
	province?: string;
	city?: string;
	postalCode?: string;
	address?: string;
	profilePic?: string;
	status: string;
	updatedAt?: Date;
	createdAt?: Date;
	firstName?: string;
	middleName?: string;
	lastName?: string;
	nickName?: string;
	lastUpdateByMeta?: any;
	authInfo?: AuthenticationData;

	userDocument?: UserDocumentProperties[];
	profile?: ProfileProperties;
	employee?: EmployeeProperties[];
	professionalInformation?: ProfessionalInformationProperties;
	emergencyContact?: EmergencyContactProperties[];
	listingCount?: number;
	portalAgent?: PortalAgentProperties[];

	closingSellCount?: number;
	closingRentCount?: number;
	totalCommission?: number;
	checkDefaultFee?: string;
};

export interface ICreateUser extends UserProperties {
	password?: string;
}

export interface UserPropertiesWithTL extends UserProperties {
	teamsMemberFees?: TeamsMemberFeeItemProperties[];
	teamsMemberFeeId?: string;
	deletedFees?: TeamsMemberFeeItemProperties[];
}

export type IChangePassword = {
	oldPassword: "";
	newPassword: "";
	retypePassword: "";
};
type IRoleList = {
	[key: string]: string;
};
export const RoleList: IRoleList = {
	admin: "HQ Super Admin",
	admin_general_manager: "HQ General Manager",
	admin_manager: "HQ Manager",
	admin_hq: "HQ Admin",
	admin_blog: "Admin Blog",
	admin_finance_gm: "HQ Finance GM", // GM Finance
	admin_finance_manager: "HQ Finance Manager", // Finance Manager
	admin_finance_staff: "HQ Finance Staff", // Finance staff

	office_user: "Office User",
};

export const AllRoleList: IRoleList = {
	admin: "HQ Super Admin",
	admin_general_manager: "HQ General Manager",
	admin_manager: "HQ Manager",
	admin_hq: "Admin HQ",
	admin_finance_gm: "HQ Finance GM",
	admin_finance_manager: "HQ Finance Manager",
	admin_finance_staff: "HQ Finance Staff",
	admin_blog: "HQ Admin Blog",

	franchise_owner: "FO",
	business_owner: "BO",
	manager_office: "Manager Office",
	finance_office: "Finance Office",
	admin_office: "Admin Office",
	agent: "Agent",
};

export const initialUser: UserProperties = {
	userId: "",
	name: "",
	email: "",
	phone: "",
	gender: "male",
	province: "",
	city: "",
	postalCode: "",
	status: "inactive",
	userType: EUserRole.office_user,
	firstName: "",
	middleName: "",
	lastName: "",
};

export type ListUserQuery = {
	filterEmployeeId?: string;
	filterUserId?: string;
	filterUserType?: string;
	filterRole?: string;
	filterRoleStatus?: string;
	filterRoleApprovalStatus?: string;
	filterOfficeId?: string;
	isStarAgent?: string;
	filterStatus?: string;
	filterCreatedByUserId?: string;
	includeData?: string;
	filterActionStartAt?: string;
	filterActionEndAt?: string;
	filterDefaultFee?: string;
	sort?: string;
	isFirstEmployeeOnly?: string;

	isAggregateSingleOffice?: string;
	filterIsBlocked?: boolean;
};

export type UserActivityLog = {
	actionType: string;
	affectedId: string;
	createdAt: string;
	metadata: any;
	newData: any;
	officeId: string;
	previousData: any;
	repositoryName: string;
	updatedAt: string;
	userActivityLogId: string;
	userId: string;
	user: UserProperties;
	employee?: EmployeeProperties;
	office?: OfficeProperties;
};
